import { render } from "./Domain.vue?vue&type=template&id=610e3bae&scoped=true"
import script from "./Domain.vue?vue&type=script&lang=js"
export * from "./Domain.vue?vue&type=script&lang=js"

import "./Domain.vue?vue&type=style&index=0&id=610e3bae&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-610e3bae"]])

export default __exports__